module.exports = __webpack_public_path__ + "img/fixedline.95724061.svg";